import { render, staticRenderFns } from "./CalendarCarrotLeftIcon.vue?vue&type=template&id=38dbe163&scoped=true&"
import script from "./CalendarCarrotLeftIcon.vue?vue&type=script&lang=js&"
export * from "./CalendarCarrotLeftIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dbe163",
  null
  
)

export default component.exports